import { Button, HStack, Th } from '@chakra-ui/react';
import React from 'react';

import {
  DEFAULT_CLEAR_SELECTION,
  DEFAULT_REMOVE_ALL,
  DEFAULT_REMOVE_SELECTED,
  DEFAULT_SELECT_ALL,
} from '@/constants/defaults';
import { FULL_WIDTH } from '@/constants/ui';
import { ELEMENT_DATA_TEST_IDS } from '@/tests/testConstants';

interface PreviewTableHeaderProps {
  handleClearSelection: () => void;
  handleRemoveAll: () => void;
  handleRemoveSelected: () => void;
  handleSelectAll: () => void;
  hasSelectedItems?: boolean;
  isDisabled?: boolean;
}

const PreviewTableHeader = (props: PreviewTableHeaderProps): React.JSX.Element => {
  const {
    handleClearSelection = () => void {},
    handleRemoveAll = () => void {},
    handleRemoveSelected = () => void {},
    handleSelectAll = () => void {},
    hasSelectedItems = false,
    isDisabled = false,
  } = props;

  const getButtons = (): JSX.Element => {
    // If we have selected items on the table we display "Remove Selected" items
    // Otherwise we display just the "Remove All" button
    if (hasSelectedItems) {
      return (
        <Button
          data-testid={ELEMENT_DATA_TEST_IDS.TABLE_HEADER_REMOVE_SELECTED_BUTTON}
          onClick={handleRemoveSelected}
          size="sm"
        >
          {DEFAULT_REMOVE_SELECTED}
        </Button>
      );
    }
    return (
      <Button
        data-testid={ELEMENT_DATA_TEST_IDS.TABLE_HEADER_REMOVE_ALL_BUTTON}
        isDisabled={isDisabled}
        onClick={handleRemoveAll}
        size="sm"
      >
        {DEFAULT_REMOVE_ALL}
      </Button>
    );
  };

  return (
    <Th w={FULL_WIDTH}>
      <HStack 
      justifyContent={'flex-end'}
      w={FULL_WIDTH} 
      >
        <Button
          data-testid={ELEMENT_DATA_TEST_IDS.TABLE_HEADER_SELECT_ALL_BUTTON}
          isDisabled={isDisabled}
          onClick={handleSelectAll}
          size="sm"
        >
          {DEFAULT_SELECT_ALL}
        </Button>
        <Button
          data-testid={ELEMENT_DATA_TEST_IDS.TABLE_HEADER_CLEAR_SELECTION_BUTTON}
          isDisabled={!hasSelectedItems}
          onClick={handleClearSelection}
          size="sm"
        >
          {DEFAULT_CLEAR_SELECTION}
        </Button>
        {getButtons()}
      </HStack>
    </Th>
  );
};

export default PreviewTableHeader;
